<template>
    <div class="container">
        <div class="page-content" v-if="deck">
            <div class="row">
                <div class="col-12">
                    <h1 class="page-heading">
                        <img src="/assets/dipocaco/pocas/shop.png" alt="shop-poca" class="page-poca">
                        Deckbuilder<br/>
                        <small class="muted">{{ deck.name }}</small>
                    </h1>
                </div>

                <div class="col-12">
                    <a href="/decks" class="btn btn-sm btn-success"><i class="fas fa-arrow-left"></i> Back to list</a>
                </div>

                <div class="col-12 col-xxl-3 my-3">
                    <div class="deck-divisions">
                        <div class="deck-division-pokemon" :style="'width: '+percentDivisionPokemon+'%'" v-text="percentDivisionPokemon.toFixed(0)+'% Pokémon'"></div>
                        <div class="deck-division-trainer" :style="'width: '+percentDivisionTrainer+'%'" v-text="percentDivisionTrainer.toFixed(0)+'% Trainer'"></div>
                        <div class="deck-division-energy" :style="'width: '+percentDivisionEnergy+'%'" v-text="percentDivisionEnergy.toFixed(0)+'% Energy'"></div>
                    </div>
                </div>

                <div class="col-12 col-xxl-9 row p-0">
                    <template v-for="card in deck.cards">
                        <div :class="'mt-2 col-xxl-1 col-xl-2 col-lg-2 col-md-3 col-sm-3 col-4 text-center collection-card '+($store.state.markers.selectingCards && card.card.isSelected === true ? 'card-is-selected' : '')">
                            <a href="javascript:" class="text-left mb-2">
                                <img loading="lazy" :src="CardService.getSmallCardImageUrl(card.card)" style="width: auto; max-width: 100%;" class="card-thumbnail rounded-3" alt="card-thumbnail">
                            </a>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardService from "../../CardService";
import HelperService from "../../HelperService";

export default {
    name: "DeckBuilder",
    data() {
        return {
            deck: [],
            loaded: false,
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.fetchUserDeck();
    },
    computed: {
        CardService() {
            return CardService
        },
        divisionPokemon() {
            return this.deck.cards.filter(c => c.card.supertype === 'Pokémon').map(c => c.quantity).summary();
        },
        divisionTrainer() {
            return this.deck.cards.filter(c => c.card.supertype === 'Trainer').map(c => c.quantity).summary();
        },
        divisionEnergy() {
            return this.deck.cards.filter(c => c.card.supertype === 'Energy').map(c => c.quantity).summary();
        },
        deckCardsTotal() {
            return this.deck.cards.map(c => c.quantity).summary();
        },
        percentDivisionPokemon() {
            return this.loaded ? (HelperService.percentage(this.divisionPokemon, this.deckCardsTotal)) : 0;
        },
        percentDivisionTrainer() {
            return this.loaded ? (HelperService.percentage(this.divisionTrainer, this.deckCardsTotal)) : 0;
        },
        percentDivisionEnergy() {
            return this.loaded ? (HelperService.percentage(this.divisionEnergy, this.deckCardsTotal)) : 0;
        },
    },
    watch: {
    },
    methods: {
        async fetchUserDeck() {
            this.deck = await fetch("/api/user-decks/"+this.$route.params.user_deck_id).then(res => res.json());
            this.loaded = true;
        }
    },
};
</script>

<style scoped lang="scss">
.deck-divisions {
    width: 100%;
    height: 2em;
    border-radius: 20px;
    color: black;

    .deck-division-pokemon {
        display: inline-block;
        background-color: orange;
        padding: 0.2em;
        text-align: center;
        vertical-align: center;
        margin: 0;
        border-radius: 20px;
    }

    .deck-division-trainer {
        display: inline-block;
        background-color: indianred;
        padding: 0.2em;
        text-align: center;
        vertical-align: center;
        margin: 0;
        border-radius: 20px;
    }

    .deck-division-energy {
        display: inline-block;
        background-color: lightblue;
        padding: 0.2em;
        text-align: center;
        vertical-align: center;
        margin: 0;
        border-radius: 20px;
    }
}
</style>
